(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-cc-ugc-open]')];
    const dialog = root.querySelector('dialog');
    const video = dialog.querySelector('video');
    const title = dialog.querySelector('[data-cc-ugc-player-title]');
    const error = dialog.querySelector('[role="status"]');
    const prev = dialog.querySelector('[data-cc-ugc-prev]');
    const next = dialog.querySelector('[data-cc-ugc-next]');
    let index = 0;
    let trigger;
    const show = n => {
      index = n;
      const card = cards[index];
      video.pause();
      error.hidden = true;
      video.src = card.dataset.video;
      video.poster = card.querySelector('img').src;
      title.textContent = card.dataset.title;
      prev.disabled = index === 0;
      next.disabled = index === cards.length - 1;
      dialog.querySelector('[data-cc-ugc-position]').textContent = `${index + 1} / ${cards.length}`;
      video.play().catch(() => {});
    };
    cards.forEach((card, n) => card.addEventListener('click', () => {
      trigger = card;
      dialog.showModal();
      document.body.classList.add('cc-ugc-open');
      show(n);
    }));
    root.querySelector('[data-cc-ugc-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.body.classList.remove('cc-ugc-open');
      trigger?.focus({ preventScroll: true });
    });
    prev.addEventListener('click', () => { if (index > 0) show(index - 1); });
    next.addEventListener('click', () => { if (index < cards.length - 1) show(index + 1); });
    video.addEventListener('error', () => { error.hidden = false; });
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
  };
  const mount = scope => scope.querySelectorAll('[data-cc-ugc]').forEach(init);
  mount(document);
  document.addEventListener('shopify:section:load', e => mount(e.target));
  document.addEventListener('shopify:section:unload', e => {
    const dialog = e.target.querySelector('.cc-ugc__dialog[open]');
    if (dialog) dialog.close();
  });
})();

